import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaEnvelope } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const ContactCTA = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleRedirect = () => {
    navigate("/contact");
  };

  return (
    <>
      <div id="contact-section" className="relative w-full h-screen flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img src="/assets/images/services/help.jpg" alt={t("common.helpAlt")} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 text-center px-12 space-y-4"
        >
          <FaEnvelope className="text-5xl text-yellow-500 mx-auto mb-2" />
          <h2 className="text-5xl font-bold">{t("contactCta.heading")}</h2>
          <p className="text-xl text-gray-300 mt-2">{t("contactCta.subtitle")}</p>
          <button
            onClick={handleRedirect}
            className="mt-6 bg-yellow-600 hover:bg-yellow-500 text-white font-bold py-4 px-10 rounded-xl shadow-lg transition-all duration-300 hover:scale-105"
          >
            {t("contactCta.button")}
          </button>
        </motion.div>
      </div>

      <button
        onClick={handleRedirect}
        className="fixed bottom-6 right-6 md:hidden bg-yellow-600 hover:bg-yellow-500 text-white font-bold py-3 px-6 rounded-full shadow-lg transition-all duration-300 animate-bounce"
      >
        {t("contactCta.button")}
      </button>
    </>
  );
};

export default ContactCTA;
